import React from 'react';
import { useTranslation } from 'react-i18next';
import { useGameFilters } from '../components/games/useGameFilters';
import { GameSubTabNav } from '../components/games/GameSubTabNav';
import { GameFilterBar } from '../components/games/GameFilterBar';
import { GroupByChips } from '../components/financial/GroupByChips';
import {
  GameOverviewPanel,
  GamePerformancePanel,
  BrandMarginPanel,
  GameTypeMixPanel,
  TopGamesPanel,
} from '../components/games/GamePanels';

// Game & Brand Performance 2.0 — single page with sub-tabs, shared URL filters.
// Sub-tabs: Overview, Game Performance, Brand Margin, Game Type Mix, Top Games.
// All filters live in the URL query string via useGameFilters(), so tab
// switching preserves selection and the page is shareable.
export const GamePerformance: React.FC = () => {
  const { t } = useTranslation();
  const filters = useGameFilters();

  // Granularity in the filter bar for Overview/Brands (no GroupByChips).
  // For Games tab, granularity is embedded in the Date chip inside GroupByChips.
  // Mix/Top tabs don't need granularity at all.
  const showGranularity = filters.subTab === 'overview' || filters.subTab === 'brands';

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-slate-900 dark:text-white">{t('gamePerformance.title')}</h1>
        <p className="mt-1 text-slate-600 dark:text-slate-400">{t('gamePerformance.subtitle')}</p>
      </div>

      <GameSubTabNav active={filters.subTab} onChange={filters.setSubTab} />

      <GameFilterBar filters={filters} showGranularity={showGranularity} />

      {filters.subTab === 'games' && (
        <GroupByChips
          value={filters.dimensions}
          onChange={filters.setDimensions}
          available={['site', 'date', 'game', 'brand', 'game_type', 'currency']}
          granularity={filters.granularity}
          onGranularityChange={filters.setGranularity}
        />
      )}

      {filters.subTab === 'overview' && <GameOverviewPanel    filters={filters} />}
      {filters.subTab === 'games'    && <GamePerformancePanel  filters={filters} />}
      {filters.subTab === 'brands'   && <BrandMarginPanel      filters={filters} />}
      {filters.subTab === 'mix'      && <GameTypeMixPanel      filters={filters} />}
      {filters.subTab === 'top'      && <TopGamesPanel         filters={filters} />}
    </div>
  );
};
